export default __webpack_public_path__ + "static/1-041cc8021f9650dcb6f9f33d4e4b2008.jpeg";